import { ChatbotButtonConfiguration } from '../pnl-chatbot-container/models/chatbot.models';


export async function GetConfiguration(baseUrl: string, buttonId: number, language: string): Promise<ChatbotButtonConfiguration> {
    let languagePart = '';
    if(language) {
        languagePart = `?language=${language}`;
    }
    const middlemanUrl = `${baseUrl}/api/chatbotConfiguration/button/${buttonId}${languagePart}`;
    var result = SendGetRequestToMiddleman<ChatbotButtonConfiguration>(middlemanUrl)

    return result;
}


function SendGetRequestToMiddleman<T>(url: string): Promise<T> {
    var response = fetch(url, {
        method: 'GET',
    }).then((res) =>
        res.json(),
        error => {
            console.error(error);
        });

    return Promise.resolve(response);
}

